<template>
  <div class="five_snail_anniversary_page">
    <div v-wechat-title="activityConfig.pageTitle"></div>

    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
      name="fade"
    >
      <div
        @touchmove.prevent
        class="preloading preloading-snail"
        v-show="preloadingShow"
      ></div>
    </transition>

    <div :class="'none ' + isWhite"></div>

    <div class="five-snail-anniversary-content">
      <div class="swiper-container" ref="mySwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide slide-page-container">
            <div class="top-container">
              <div
                class="big-title"
                :style="bg(activityConfig.home.bigTitle)"
              ></div>

              <div
                v-if="rightTitleClass"
                :class="rightTitleClass"
                :style="rightTitleStyle"
              ></div>

              <div></div>
            </div>

            <div class="anniversary-swiper-box popup_wrap-box">
              <div class="swiper-container-2">
                <div class="slide-box">
                  <img
                    v-if="swiperList.length"
                    :key="currentIndex"
                    :src="swiperList[currentIndex].photo"
                    @click="showImage(swiperList[currentIndex].photo)"
                  />
                </div>

                <div class="next-btn" @click="nextImage"></div>
              </div>

              <div class="star_1"></div>
              <div class="star_2"></div>
              <div class="star_3"></div>
              <div class="tip_text" v-if="actual_quantity"></div>
            </div>

            <div class="role-container"></div>

            <div class="rule-box">
              <a
                href="javascript:;"
                class="rule-btn"
                @click="ruleShow = true"
              ></a>
            </div>

            <div class="aniv-box">
              <a
                href="javascript:;"
                class="aniv-btn"
                @click="goAnniversary"
              ></a>
            </div>

            <div
              :class="
                rewardPanelType === 3
                  ? 'reward-container_3'
                  : 'reward-container_2'
              "
            >
              <div class="reward-box">
                <div @click="openPayDialog(3)" class="left-box">
                  <i v-if="firstNoClick"></i>
                </div>
                <div class="first-light"></div>

                <div @click="openPayDialog(1)" class="center-box">
                  <i v-if="secondNoClick"></i>
                </div>
                <div class="second-light"></div>
                <div class="second-star"></div>

                <template v-if="rewardPanelType === 3">
                  <div @click="openPayDialog(2)" class="right-box">
                    <i v-if="thirdNoClick"></i>
                  </div>
                  <div class="third-light"></div>
                  <div class="third_star_1"></div>
                  <div class="third_star_2"></div>
                  <div class="light-bg"></div>
                </template>
              </div>
            </div>

            <div class="btn-box">
              <div class="top-box">
                <a
                  v-if="canBuy"
                  @click="openPayDialog(3)"
                  :class="btnClasses.welfare"
                  href="javascript:;"
                >
                  <i v-if="firstNoClick"></i>
                </a>

                <div class="no_time-container" v-else>
                  <a
                    @click="openPayDialog(3)"
                    :class="btnClasses.notTime"
                    href="javascript:;"
                  ></a>
                  <p :class="btnClasses.bottomText">
                    {{
                      formatText(activityConfig.copy.welfareUnlock, {
                        time: compCountdown,
                      })
                    }}
                  </p>
                </div>

                <template v-if="is_pay === 0">
                  <a
                    @click="openPayDialog(1)"
                    :class="btnClasses.anniversary"
                    href="javascript:;"
                  >
                    <i v-if="secondNoClick"></i>
                  </a>

                  <a
                    v-if="rewardPanelType === 3"
                    @click="openPayDialog(2)"
                    class="collection-btn"
                    href="javascript:;"
                  >
                    <i v-if="thirdNoClick"></i>
                  </a>
                </template>

                <template v-if="userInfo.role_id && is_pay > 0">
                  <a
                    v-if="!address && !end_address"
                    class="address-btn-anniversary"
                    href="javascript:;"
                    @click="openAddress"
                  ></a>

                  <a
                    v-if="address && !end_address"
                    class="modify-btn"
                    href="javascript:;"
                    @click="openAddress"
                  ></a>

                  <p v-if="address && !end_address" class="time-text">
                    剩余时间 {{ formattedTime }}
                  </p>

                  <a
                    v-if="end_address"
                    class="look-btn"
                    href="javascript:;"
                    @click="openAddress"
                  ></a>
                </template>
              </div>
            </div>

            <div class="bottom-item"></div>
          </div>

          <div class="swiper-slide foot-page">
            <Footer :gameName="gameName" />
          </div>
        </div>
      </div>
    </div>

    <Header :isOnline="1" :config="headerConfig" />

    <Login
      v-if="isShowLogin"
      v-on:channelCallback="selectCallback"
      :gameName="gameName"
      :loginTypes="loginTypes"
      :downloadUrl="activityConfig.urls.download"
      :channelTips="activityConfig.copy.channelTips"
      noAuthLogin
    ></Login>

    <Os
      v-if="isShowOs"
      v-on:selectCallback="selectCallback"
      v-on:logoutCallback="osCancell"
      :gameName="gameName"
    ></Os>

    <!-- 规则弹窗 -->
    <div
      :class="['rule-wrap popup_wrap', `rule-wrap-${ruleShow}`]"
      v-show="ruleShow"
    >
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
        :duration="{ enter: 1000 }"
      >
        <div
          class="rule-box popup_wrap-box"
          v-show="ruleShow"
          :style="bg(activityConfig.rule.popupBg)"
        >
          <div class="rule_text_out">
            <img class="rule_text" :src="activityConfig.rule.textImage" />
          </div>
        </div>
      </transition>
      <div class="close-bg" @click="ruleShow = false"></div>
    </div>

    <!-- 贵重品弹窗 -->
    <div
      :class="['expensive-wrap popup_wrap', `expensive-wrap-${expensiveShow}`]"
      v-show="expensiveShow"
    >
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
        :duration="{ enter: 1000 }"
      >
        <div
          class="expensive-box popup_wrap-box"
          v-show="expensiveShow"
          :style="bg(activityConfig.expensive.popupBg)"
        ></div>
      </transition>
      <div class="close-bg" @click="expensiveShow = false"></div>
    </div>

    <!-- 图片预览弹窗 -->
    <div
      :class="['preview-wrap', `preview-wrap-${previewShow}`]"
      v-show="previewShow"
    >
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
        :duration="{ enter: 1000 }"
      >
        <div class="preview-box" v-show="previewShow">
          <img :src="nowImg" />
        </div>
      </transition>
      <div class="close-bg" @click="previewShow = false"></div>
    </div>

    <!-- 福利礼包弹窗 -->
    <div
      :class="['welfare-wrap popup_wrap', `welfare-wrap-${welfareShow}`]"
      v-show="welfareShow"
    >
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
        :duration="{ enter: 1000 }"
      >
        <div
          class="welfare-box popup_wrap-box"
          v-show="welfareShow"
          :style="bg(activityConfig.welfare.popupBg)"
        >
          <div class="get-btn-box">
            <a
              @click="getReward"
              v-if="!canBuy || !reawrd_status"
              class="get-btn"
              href="javascript:;"
            ></a>

            <a
              @click="reReward"
              v-if="canBuy && reawrd_status"
              class="not-get-btn"
              href="javascript:;"
            ></a>
          </div>

          <div class="reward-list-wrapper">
            <div class="list-content">
              <div
                :class="['list-item', item.key]"
                :style="bg(item.image)"
                v-for="(item, index) in welfareRewards"
                :key="item.key || index"
              ></div>
            </div>
          </div>

          <div v-if="!canBuy" class="end-tip-text">
            <p>
              {{
                formatText(activityConfig.copy.welfareUnlock, {
                  time: compCountdown,
                })
              }}
            </p>
          </div>
        </div>
      </transition>

      <div class="close-bg" @click="welfareShow = false"></div>
    </div>

    <!-- 购买纪念章弹窗 -->
    <div
      :class="[
        'anniversary-wrap popup_wrap',
        `aniniversary-wrap-${buyAnniversaryShow}`,
      ]"
      v-show="buyAnniversaryShow"
    >
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
        :duration="{ enter: 1000 }"
      >
        <div class="anniversary-box popup_wrap-box" v-show="buyAnniversaryShow">
          <div
            :class="anniversaryTitleClass"
            :style="anniversaryTitleStyle"
          ></div>

          <div class="anniversary-item" :style="anniversaryMedalStyle">
            <div :class="anniversaryDescClass"></div>
          </div>

          <div class="reward-list-wrapper">
            <div class="list-content-wrapper">
              <div class="list-content">
                <div
                  @click="isExpensiveItem(item)"
                  :class="['list-item', item.key]"
                  :style="bg(item.image)"
                  v-for="(item, index) in rewardShowList"
                  :key="item.key || index"
                ></div>
              </div>
            </div>
          </div>

          <div v-if="is_pay === 0 && canBuy" class="bottom-container">
            <div class="bottom-box">
              <div @click="goToPay('wechat')" class="wechat-btn"></div>
              <div @click="goToPay('alipay')" class="zfb-btn"></div>
            </div>
          </div>

          <div v-if="canBuy" class="quality-text"></div>

          <div v-if="!canBuy" class="end-tip-text">
            <p>
              {{
                formatText(activityConfig.copy.badgeUnlock, {
                  time: compCountdown,
                })
              }}
            </p>
          </div>
        </div>
      </transition>

      <div class="close-bg" @click="closeAnniversary"></div>
    </div>

    <!-- 地址信息弹窗 -->
    <div
      :class="[
        is_pay == 1 ? 'znk-address-wrap' : 'dck-address-wrap',
        'popup_wrap',
      ]"
      v-show="addressShow"
    >
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
        :duration="{ enter: 1000 }"
      >
        <div
          class="address-box popup_wrap-box"
          v-show="addressShow"
          :style="bg(activityConfig.address.popupBg)"
        >
          <div
            v-if="activityConfig.address.medalImage"
            class="address-medal"
            :style="bg(activityConfig.address.medalImage)"
          ></div>

          <div
            v-for="field in addressFields"
            :key="field.key"
            :class="field.class"
          >
            <label>
              <input
                :type="field.type"
                v-model.trim="$data[field.key]"
                :disabled="end_address"
                :maxlength="field.maxlength"
                @focus="
                  field.key === 'selected' && !end_address
                    ? (showArea = true)
                    : null
                "
                :readonly="field.readonly"
              />
            </label>
          </div>

          <div
            class="city-box"
            @click="!end_address && (showArea = true)"
          ></div>

          <div class="address_class">
            <label>
              <textarea
                v-model.trim="address"
                :disabled="end_address"
              ></textarea>
            </label>
          </div>

          <div class="delivery_class">
            <label>
              <input
                disabled
                type="text"
                :value="odd_number || no_add_number"
              />
            </label>
          </div>

          <div
            id="odd_number"
            @click="handleCopy('#odd_number', '复制成功')"
            :data-clipboard-text="odd_number"
            class="clipboard_class"
          ></div>

          <div v-if="!end_address" class="affirm" @click="submitInfo"></div>
          <div class="close-bg" @click="addressShow = false"></div>
        </div>
      </transition>
    </div>

    <van-popup v-model="showArea" position="bottom" round class="custom-popup">
      <van-area
        :area-list="areaList"
        @confirm="onConfirm"
        @cancel="showArea = false"
      />
    </van-popup>

    <!-- 支付提示 -->
    <div class="payment_tips_page popup_wrap" v-show="paymentTipsShow">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="payment_tips_box" v-show="paymentTipsShow">
          <h2>提示</h2>
          <p>请确认是否完成支付</p>
          <div>
            <a @click="orderQuery(1)" href="javascript:;">已完成支付</a>
            <a @click="orderQuery(2)" href="javascript:;">未完成支付</a>
          </div>
        </div>
      </transition>
    </div>

    <!-- webview 内微信支付提示 -->
    <div class="web_tips_page popup_wrap" v-show="payTipShow">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="web_tips_box" v-show="payTipShow">
          <h2>支付提示</h2>
          <div class="tip-text">
            <p>
              {{ activityConfig.copy.wechatPayTip }}<br />
              <span class="highlight">
                {{ activityConfig.copy.wechatPayTipHighlight }}
              </span>
            </p>
          </div>
          <div>
            <a class="cancel" @click="payTipShow = false" href="javascript:;"
              >取消</a
            >
            <a
              id="url_link"
              @click="handleCopy('#url_link', '复制成功，请前往浏览器')"
              :data-clipboard-text="url_link"
              href="javascript:;"
              >复制链接</a
            >
          </div>
        </div>
      </transition>
    </div>

    <!-- 上一笔订单未支付提示 -->
    <div class="payment_tips_page popup_wrap" v-show="fePaymentTipsShow">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="payment_tips_box" v-show="fePaymentTipsShow">
          <h2>提示</h2>
          <p>您有一笔订单是否继续支付</p>
          <div>
            <a @click="cancelOrder" href="javascript:;">关闭取消支付</a>
            <a @click="goOnPay" href="javascript:;">继续前往支付</a>
          </div>
        </div>
      </transition>
    </div>

    <!-- 付款失败 -->
    <div class="payment-failed-wrap popup_wrap" v-show="paymentFailedShow">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="popup-wrap-box" v-show="paymentFailedShow">
          <div class="btn-box-sure">
            <a href="javascript:;" @click="payFail">确定</a>
          </div>
        </div>
      </transition>
      <div class="close-bg" @click="paymentFailedShow = false"></div>
    </div>

    <!-- 微信里的支付宝引导 -->
    <div class="wx_download_wrap popup_wrap" v-show="zfbShow">
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }"
      >
        <div class="wx_download_wrap_content" @click="zfbShow = false"></div>
      </transition>
      <div class="close-bg" v-if="zfbShow" @click="zfbShow = false"></div>
    </div>

    <!-- 开屏 MP4 视频 -->
    <div class="content-01" :style="'visibility: ' + showVideo">
      <video
        ref="openingVideo"
        class="opening-video"
        :src="activityConfig.video.openingMp4"
        muted
        playsinline
        webkit-playsinline
        x5-playsinline
        preload="auto"
        @canplay="onOpeningVideoCanPlay"
        @ended="onOpeningVideoEnded"
      ></video>
    </div>

    <div id="aliPayBtn"></div>

    <div
      @touchmove.prevent
      :class="['prevent-wrap', `prevent-wrap-${preventShow}`]"
    ></div>
  </div>
</template>

<script>
import { Popup, Area } from "vant";
import { areaList } from "@vant/area-data";
import { Toast, Indicator } from "mint-ui";
import { mapState, mapMutations, mapActions } from "vuex";
import Os from "@/components/os";
import Login from "@/components/login";
import Header from "../Header/index.vue";
import Footer from "@/components/Footer";
import { headerConfig } from "../headerConfig";
import Clipboard from "clipboard";
import {
  hasActualQuality,
  onGetInitDataAPI,
  getRewardApi,
  modifyAddressApi,
  craeteOrderApi,
  checkOrderAPI,
  wechatInfoAPI,
  orderOff,
} from "../api";
import {
  getTimeStamp,
  wechatBrowser,
  buriedLogger,
  getRandomString,
  analysisParams,
} from "@/utils/utils";

const commonConfig = {
  resistanceRatio: 0,
  mousewheelControl: true,
  speed: 500,
  parallax: true,
  slidesPerView: "auto",
  lazyLoading: true,
  lazyLoadingInPrevNext: true,
  preloadImages: false,
  observer: true,
  observeParents: true,
};

const PAY_STATUS = {
  UNPAID: 0,
  ANNIVERSARY_EDITION: 1,
  COLLECTOR_EDITION: 2,
};

/**
 * 当前无后台接口，先使用本地配置。
 * 你要替换图片，就改这里的 URL。
 */
const FIVE_MAIN_IMAGE_URL = "https://download4.qcplay.com/snail/five-anniversary/";
const FIVE_POPUP_IMAGE_URL = "https://download4.qcplay.com/snail/five-anniversary/popup/";

const DEFAULT_ANNIVERSARY_CONFIG = {
  activityCode: "snail_anniversary_badge",
  periods: 3,
  anniversaryNo: 6,

  pageTitle: "六周年纪念章",
  loggerPrefix: "蜗牛_六周年_纪念章h5",

  video: {
    /**
     * 你原页面用的是 jsmpeg + canvas 播放 ts：
     * https://download4.qcplay.com/snail/out/out.ts
     *
     * 如果当前 index.vue 已经改成 <video> 播 MP4，
     * 这里暂时没有五周年 MP4，所以 openingMp4 先留空。
     */
    openingMp4: "",

    /**
     * 原页面已确定的视频地址。
     */
    openingTs: "https://download4.qcplay.com/snail/out/out.ts"
  },

  home: {
    /**
     * 主标题 big-title
     */
    bigTitle: `${FIVE_MAIN_IMAGE_URL}big_title.png`,

    /**
     * 纪念奖章正面 slide-box
     * 这两个来自你原 Vue data 里的 swiperList。
     */
    medalFront: "https://download4.qcplay.com/qcgame-api/c0YV4CpVtHMRUH9cx3S0y9Qi3Us3EwaXp0xqWLya.png",

    /**
     * 纪念奖章反面 slide-box
     */
    medalBack: "https://download4.qcplay.com/qcgame-api/iZII5UMoRZ3QxKKyVS6PcHtfQDlGecZwizwG9vVR.png",

    /**
     * 发售前文案 right-title-1
     */
    rightTitleBeforeSale: `${FIVE_MAIN_IMAGE_URL}right_title_1.png`,

    /**
     * 典藏款售完前文案 right-title-2
     */
    rightTitleOnSale: `${FIVE_MAIN_IMAGE_URL}right_title_2.png`,

    /**
     * 典藏款售完后文案 right-title-3
     */
    rightTitleSoldOut: "https://download4.qcplay.com/qcgame-api/8CooMeI4bt0N0X9Yq7LAjXhyB3C7bQDocIKXJm5i.png",

    /**
     * 购买周年款后文案 right-title-4
     */
    rightTitlePaidAnniversary: `${FIVE_MAIN_IMAGE_URL}right_title_4.png`,

    /**
     * 购买典藏款后文案 right-title-5
     */
    rightTitlePaidCollector: `${FIVE_MAIN_IMAGE_URL}right_title_5.png`
  },

  rule: {
    /**
     * 活动规则弹窗-标题/底图 rule-box
     */
    popupBg: `${FIVE_POPUP_IMAGE_URL}rule_pop.png`,

    /**
     * 活动规则文案图 rule_text
     * 来自你原 Vue data 里的 ruleSrc。
     */
    textImage: "https://download4.qcplay.com/qcgame-api/mLdSTGiTEvzhj3FNIiiHImNTb0UX6fs6mG9zLcxo.png"
  },

  welfare: {
    /**
     * 福利礼包弹窗-标题/底图 welfare-box
     */
    popupBg: `${FIVE_POPUP_IMAGE_URL}welfare_pop.png`,

    rewards: [
      {
        /**
         * 福利礼包弹窗-福利1 bkd-300
         */
        key: "bkd-300",
        image: `${FIVE_MAIN_IMAGE_URL}bkd_300.png`
      },
      {
        /**
         * 福利礼包弹窗-福利2 cjq-5
         */
        key: "cjq-5",
        image: "https://download4.qcplay.com/qcgame-api/NMkg9Dd7yPwIzRyjByT5DYDCsqNSKvapOTVOwnAD.png"
      },
      {
        /**
         * 福利礼包弹窗-福利3 jnz-10
         */
        key: "jnz-10",
        image: `${FIVE_MAIN_IMAGE_URL}jnz_10.png`
      }
    ]
  },

  anniversary: {
    /**
     * 纪念奖章周年款弹窗-标题 first-anniversary
     */
    titleImage: `${FIVE_POPUP_IMAGE_URL}first_text.png`,

    /**
     * 已购买周年款后标题 third-anniversary
     */
    ownedTitleImage: `${FIVE_POPUP_IMAGE_URL}anniversary_text.png`,

    /**
     * 纪念奖章周年款弹窗-奖章图 anniversary-item
     */
    medalImage: `${FIVE_POPUP_IMAGE_URL}anniversary_item.png`,

    /**
     * 周年款描述 first-desc
     * 如果你后面想把 first-desc 也配置化，可以用这个字段。
     */
    descImage: `${FIVE_POPUP_IMAGE_URL}first_desc.png`,

    rewards: [
      {
        /**
         * 周年款奖励1 znk-gzp
         */
        key: "znk-gzp",
        image: `${FIVE_MAIN_IMAGE_URL}znk_gzp.png`,
        expensive: true
      },
      {
        /**
         * 周年款奖励2 avatar-b
         */
        key: "avatar-b",
        image: `${FIVE_MAIN_IMAGE_URL}avatar_b.png`
      },
      {
        /**
         * 周年款奖励3 bkd-600
         */
        key: "bkd-600",
        image: `${FIVE_MAIN_IMAGE_URL}bkd_600.png`
      },
      {
        /**
         * 周年款奖励4 cjq-10
         */
        key: "cjq-10",
        image: "https://download4.qcplay.com/qcgame-api/Te32H70E9IgeOqQ2VKhStStFHXIr5H48PRhKu4jX.png"
      },
      {
        /**
         * 周年款奖励5 jnz-30
         */
        key: "jnz-30",
        image: `${FIVE_MAIN_IMAGE_URL}jnz_30.png`
      }
    ]
  },

  collector: {
    /**
     * 纪念奖章典藏款弹窗-标题 second-anniversary
     */
    titleImage: `${FIVE_POPUP_IMAGE_URL}second_text.png`,

    /**
     * 已购买典藏款后标题 four-anniversary
     */
    ownedTitleImage: `${FIVE_POPUP_IMAGE_URL}collect_text.png`,

    /**
     * 典藏款目前和周年款共用 anniversary_item.png
     */
    medalImage: `${FIVE_POPUP_IMAGE_URL}anniversary_item.png`,

    /**
     * 典藏款描述 second-desc
     * 如果后面想把 second-desc 也配置化，可以用这个字段。
     */
    descImage: `${FIVE_POPUP_IMAGE_URL}second_desc.png`,

    rewards: [
      {
        /**
         * 典藏款奖励1 dck-gzp
         */
        key: "dck-gzp",
        image: `${FIVE_MAIN_IMAGE_URL}dck_gzp.png`,
        expensive: true
      },
      {
        /**
         * 典藏款奖励2 avatar-a
         */
        key: "avatar-a",
        image: `${FIVE_MAIN_IMAGE_URL}avatar_a.png`
      },
      {
        /**
         * 典藏款奖励3 bkd-1000
         */
        key: "bkd-1000",
        image: `${FIVE_MAIN_IMAGE_URL}bkd_1000.png`
      },
      {
        /**
         * 典藏款奖励4 cjq-20
         */
        key: "cjq-20",
        image: "https://download4.qcplay.com/qcgame-api/uyjIDqyjTV9FIK4erMoS9bkUWuQuADtzlQUtT0Fs.png"
      },
      {
        /**
         * 典藏款奖励5 jnz-50
         */
        key: "jnz-50",
        image: `${FIVE_MAIN_IMAGE_URL}jnz_50.png`
      }
    ]
  },

  expensive: {
    /**
     * 贵重品详情弹窗 expensive-box
     */
    popupBg: `${FIVE_POPUP_IMAGE_URL}expensive_pop.png`
  },

  address: {
    /**
     * 周年款地址弹窗 znk-address-wrap .address-box
     */
    anniversaryPopupBg: `${FIVE_POPUP_IMAGE_URL}znk_address.png`,

    /**
     * 典藏款地址弹窗 dck-address-wrap .address-box
     */
    collectorPopupBg: `${FIVE_POPUP_IMAGE_URL}dck_address.png`,

    /**
     * 兼容旧字段。
     * 如果你的代码里还在用 activityConfig.address.popupBg，
     * 可以先默认用周年款地址弹窗。
     */
    popupBg: `${FIVE_POPUP_IMAGE_URL}znk_address.png`,

    /**
     * 你当前 less 中地址弹窗纪念章图已经包含在 znk_address.png / dck_address.png 里，
     * 所以这里留空。
     */
    medalImage: ""
  },

  urls: {
    /**
     * 原页面 goAnniversary 跳转地址
     */
    anniversary: "https://qcg.ink/42tW94",

    /**
     * 原页面下载地址
     */
    download: "http://snail.qingcigame.com/official/",

    pc: "/snail/anniversaryBadge/pc",
    enter: "/snail/anniversaryBadge/enter"
  },

  share: {
    /**
     * 原页面分享配置
     */
    title: "《最强蜗牛》六周年纪念奖章",
    desc: "六周年限定纪念奖章强势来袭！周年专属，错过再等一年！",
    imgUrl: "https://download4.qcplay.com/qcgame-api/7BjM8kVaE5122hic2slbpfCmfvyMjmBWeEoKXtZ3.png"
  },

  copy: {
    channelTips: "角色UID可在游戏中—设置—UID查看",
    welfareUnlock: "福利礼包还剩{time}解锁！",
    badgeUnlock: "奖章礼包还剩{time}解锁！",
    wechatPayTip: "微信暂时无法支付，推荐使用支付宝！",
    wechatPayTipHighlight: "（可复制链接使用浏览器，进行微信支付）"
  }
};

export default {
  name: "anniversary",

  components: {
    Header,
    Footer,
    Login,
    Os,
    [Popup.name]: Popup,
    [Area.name]: Area,
  },

  data() {
    return {
      activityConfig: JSON.parse(JSON.stringify(DEFAULT_ANNIVERSARY_CONFIG)),
      initPromise: null,
      logger: null,

      url_link: "",
      payTipShow: false,

      remainingSeconds: 0,
      timer1: null,
      end_time: "",

      currentIndex: 0,

      provincial: "",
      city: "",
      area: "",

      showArea: false,
      areaList,
      selected: "",

      showVideo: "hidden",
      isWhite: "",

      reawrd_status: false,
      end_address: false,
      old_order: null,

      rewardShowList: [],

      zfbShow: false,
      no_add_number: "未发货",
      odd_number: "",

      name: "",
      phone: "",
      address: "",

      is_pay: 0,

      firstNoClick: true,
      secondNoClick: true,
      thirdNoClick: true,

      welfareShow: false,
      canBuy: true,

      timer: null,
      compCountdown: "",
      countdown: "",

      buyType: "",

      nowImg: "",
      buyAnniversaryShow: false,
      expensiveShow: false,
      previewShow: false,
      addressShow: false,

      headerConfig,
      gameName: "snail",
      loginTypes: ["sms", "password", "channel"],

      preloadingShow: false,
      preventShow: false,
      ruleShow: false,
      actual_quantity: false,

      paymentTipsShow: false,
      fePaymentTipsShow: false,
      isWechatBrowser: false,

      my_payment_select: 0,
      paymentData: "",
      open_id: "",

      paymentList: [
        {
          icon: "zfb",
          name: "支付宝支付",
          select: "1",
          payType: "alipay",
          payMethod: "wap",
        },
        {
          icon: "wx",
          name: "微信支付",
          select: "0",
          payType: "wechat",
          payMethod: "mp",
        },
      ],

      paymentList3: [
        {
          icon: "wx",
          name: "微信支付",
          select: "1",
          payType: "wechat",
          payMethod: "mp",
        },
      ],

      paymentFailedShow: false,
    };
  },

  created() {
    window.addEventListener("pageshow", this.resize);
    window.addEventListener("resize", this.resize);
    this.initPromise = this.initPage();
  },

  async mounted() {
    await this.initPromise;

    this.$nextTick(() => {
      const { protocol, host } = window.location;

      const enterPath =
        this.activityConfig.urls.enter || "/snail/anniversaryBadge/enter";
      const pcPath =
        this.activityConfig.urls.pc || "/snail/anniversaryBadge/pc";

      const enterLink = `${protocol}//${host}${enterPath}${getRandomString()}`;
      const pcLink = `${protocol}//${host}${pcPath}`;

      this.url_link = window.location.origin + window.location.pathname;

      this.monitoringEquipmentPc(pcLink);
      this.isSetShare(enterLink);
      this.anniverSarySwiper();

      this.logger = buriedLogger(
        this.gameName,
        this.activityConfig.loggerPrefix
      );

      setTimeout(() => {
        this.log("活动页统计");
      }, 200);
    });
  },

  methods: {
    async initPage() {
      await this.loadActivityConfig();

      this.isWechatBrowser = wechatBrowser();

      hasActualQuality({
        periods: this.currentPeriod,
      }).then((response) => {
        if (Number(response.code) === 200) {
          this.actual_quantity = response.data.actual_quantity;
        } else {
          this.onToast(response.message);
        }
      });

      if (this.isWechatBrowser) {
        wechatInfoAPI({
          periods: this.currentPeriod,
        }).then((response) => {
          if (Number(response.code) === 200) {
            this.open_id = response.data.open_id;

            if (response.data.open_id == null) {
              window.location.href =
                "//api.qingcigame.com/wechat/get/open/?back=" +
                encodeURIComponent(window.location.href);
              return;
            }

            this.getLoginContainer();
          } else {
            this.getLoginContainer();
            this.onToast(response.message);
          }
        });
      } else {
        this.getLoginContainer();
      }
    },

    /**
     * 暂时没有后台接口，先使用本地配置。
     * 后续后台接口完成后，只需要改这个方法即可。
     */
    async loadActivityConfig() {
      const query = analysisParams(window.location.href) || {};
      const localConfig = JSON.parse(
        JSON.stringify(DEFAULT_ANNIVERSARY_CONFIG)
      );

      if (query.periods) {
        localConfig.periods = Number(query.periods);
      }

      if (query.anniversaryNo || query.anniversary_no) {
        localConfig.anniversaryNo = Number(
          query.anniversaryNo || query.anniversary_no
        );
      }

      if (query.pageTitle || query.page_title) {
        localConfig.pageTitle = query.pageTitle || query.page_title;
      }

      this.activityConfig = localConfig;

      console.log("当前周年模板配置：", this.activityConfig);
    },

    bg(url) {
      return {
        background: url
          ? `url("${url}") center center / contain no-repeat`
          : "none",
      };
    },

    formatText(template, data = {}) {
      if (!template) return "";

      return template.replace(/\{(\w+)\}/g, (_, key) => {
        return data[key] !== undefined ? data[key] : "";
      });
    },

    log(action) {
      if (!this.logger) return;

      const prefix = this.activityConfig.loggerPrefix || "蜗牛_周年纪念章h5";
      this.logger.sum(`${prefix}_${action}`);
    },

    goAnniversary() {
      const url = this.activityConfig.urls.anniversary;

      if (!url) {
        this.onToast("活动地址未配置");
        return;
      }

      window.location.href = url;
    },

    initCountdown() {
      if (!this.end_time) return;

      const baseTime = new Date(this.end_time.replace(/-/g, "/"));
      const targetTime = new Date(baseTime.getTime() + 48 * 60 * 60 * 1000);
      const now = new Date();
      const diff = Math.floor((targetTime - now) / 1000);

      this.remainingSeconds = diff > 0 ? diff : 0;

      this.timer1 = setInterval(() => {
        if (this.remainingSeconds > 0) {
          this.remainingSeconds--;
        } else {
          clearInterval(this.timer1);
          this.timer1 = null;
        }
      }, 1000);
    },

    nextImage() {
      if (!this.swiperList.length) return;
      this.currentIndex = (this.currentIndex + 1) % this.swiperList.length;
    },

    onConfirm(e) {
      this.provincial = e[0].name;
      this.city = e[1].name;
      this.area = e[2].name;
      this.selected = e[0].name + " " + e[1].name + " " + e[2].name;
      this.showArea = false;
    },

    monitoringEquipmentPc(pcLink) {
      if (!/(iPhone|iPod|mobile|Android|ios)/i.test(navigator.userAgent)) {
        location.href = pcLink;
      }
    },

    resize() {
      if (window.innerWidth / window.innerHeight > 320 / 470) {
        document
          .querySelectorAll(".popup_wrap .popup_wrap-box")
          .forEach((item) => {
            item.style.transform = "scale(0.75)";
          });
      } else if (window.innerWidth / window.innerHeight > 320 / 520) {
        document
          .querySelectorAll(".popup_wrap .popup_wrap-box")
          .forEach((item) => {
            item.style.transform = "scale(0.85)";
          });
      } else if (window.innerWidth / window.innerHeight > 320 / 560) {
        document
          .querySelectorAll(".popup_wrap .popup_wrap-box")
          .forEach((item) => {
            item.style.transform = "scale(0.9)";
          });
      } else if (window.innerWidth / window.innerHeight > 320 / 620) {
        document
          .querySelectorAll(".popup_wrap .popup_wrap-box")
          .forEach((item) => {
            item.style.transform = "scale(0.95)";
          });
      }
    },

    video() {
      const url = this.activityConfig.video.openingMp4;

      if (!url) {
        this.showVideo = "hidden";
        this.preloadingShow = false;
        localStorage.setItem(this.videoStorageKey, "1");
        return;
      }

      this.$nextTick(() => {
        const video = this.$refs.openingVideo;

        if (!video) {
          this.showVideo = "hidden";
          this.preloadingShow = false;
          return;
        }

        video.currentTime = 0;

        const playPromise = video.play();

        if (playPromise && playPromise.catch) {
          playPromise.catch(() => {
            this.showVideo = "hidden";
            this.preloadingShow = false;
            localStorage.setItem(this.videoStorageKey, "1");
          });
        }
      });
    },

    onOpeningVideoCanPlay() {
      this.showVideo = "visible";
      this.preloadingShow = false;
    },

    onOpeningVideoEnded() {
      this.showVideo = "hidden";
      localStorage.setItem(this.videoStorageKey, "1");
    },

    openAddress() {
      this.getLoginContainer();
      this.addressShow = true;
      this.log("点击收货地址按钮");
    },

    payFail() {
      this.paymentFailedShow = false;
      this.getLoginContainer();
      this.log("点击支付失败的确定按钮");
    },

    cancelOrder() {
      orderOff({
        periods: this.currentPeriod,
      })
        .then((response) => {
          if (Number(response.code) === 200) {
            this.fePaymentTipsShow = false;
            this.getLoginContainer();
          }
          this.onToast(response.message);
        })
        .catch(() => {
          this.onToast("服务器出错啦");
        });

      this.log("取消支付按钮");
    },

    reReward() {
      this.onToast("很抱歉,您已经领取过");
    },

    goOnPay() {
      window.location.href = this.old_order;

      setTimeout(() => {
        this.preventShow = false;
      }, 1000);

      this.log("点击支付上一笔订单的按钮");
    },

    goToPay(payType) {
      if (payType === "wechat") {
        const { ua } = analysisParams(window.location.href);

        if (ua === "snail") {
          this.payTipShow = true;
          return;
        }
      }

      if (this.paymentList.length > 1) {
        this.paymentList[1].payMethod = this.isWechatBrowser ? "mp" : "wap";
      }

      if (this.isWechatBrowser && payType === "alipay") {
        this.preventShow = false;
        this.zfbShow = true;
        return;
      }

      const type = this.buyType === 1 || this.buyType === 3 ? 0 : 1;

      if (this.paymentList.length > 1) {
        this.my_payment_select = payType === "wechat" ? 1 : 0;

        for (let i = 0; i <= this.paymentList.length - 1; i++) {
          this.paymentList[i].select = 0;
        }

        this.paymentList[this.my_payment_select].select = 1;
        this.paymentData = this.paymentList[this.my_payment_select];
      } else {
        this.paymentData = this.paymentList3[0];
      }

      this.preventShow = true;

      if (!this.isWechatBrowser && this.old_order) {
        this.fePaymentTipsShow = true;

        setTimeout(() => {
          this.preventShow = false;
        }, 500);

        return;
      }

      craeteOrderApi({
        pay_type: this.paymentData.payType,
        pay_method: this.paymentData.payMethod,
        open_id: this.open_id,
        type,
        periods: this.currentPeriod,
      }).then((response) => {
        if (response.message === "很抱歉,典藏款已被抢完~") {
          this.onToast(response.message, 2000);
          this.buyAnniversaryShow = false;
          this.getLoginContainer();

          setTimeout(() => {
            this.preventShow = false;
          }, 500);

          return;
        }

        if (Number(response.code) === 200) {
          this.order = response.data.order;
          this.paymentTipsShow = true;

          if (/(iPhone|iPod|Android|ios)/i.test(navigator.userAgent)) {
            if (this.paymentData.payType === "wechat") {
              if (this.paymentData.payMethod === "mp") {
                wx.chooseWXPay({
                  timestamp: response.data.data.timeStamp,
                  nonceStr: response.data.data.nonceStr,
                  package: response.data.data.package,
                  signType: response.data.data.signType,
                  paySign: response.data.data.paySign,
                  success: () => {
                    setTimeout(() => {
                      this.preventShow = false;
                    }, 1000);
                  },
                  fail: () => {
                    setTimeout(() => {
                      this.preventShow = false;
                    }, 1000);
                  },
                });

                setTimeout(() => {
                  this.preventShow = false;
                }, 2000);
              } else if (response.data.data !== "") {
                window.location.href = response.data.data;

                setTimeout(() => {
                  this.preventShow = false;
                }, 1000);
              }
            } else if (response.data.data !== "") {
              document.getElementById("aliPayBtn").innerHTML =
                response.data.data;
              document.forms["alipaysubmit"].submit();

              setTimeout(() => {
                this.preventShow = false;
              }, 1000);
            }
          }

          this.log("点击购买按钮");
          return;
        }

        this.onToast(response.message, 2000);

        setTimeout(() => {
          this.preventShow = false;
        }, 500);
      });
    },

    timeFormatted(str) {
      const secondsNum = Number(str || 0);
      const hours = Math.floor(secondsNum / 3600);
      const minutes = Math.floor((secondsNum % 3600) / 60);
      const seconds = secondsNum % 60;

      return `${hours}:${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;
    },

    handleCopy(my_id, successMsg) {
      const clipboard = new Clipboard(my_id);

      clipboard.on("success", (e) => {
        this.onToast(successMsg, 1000);
        e.clearSelection();
      });

      clipboard.on("error", () => {
        this.onToast("复制失败", 1000);
      });
    },

    orderQuery(type) {
      this.paymentTipsShow = false;
      this.wait = type === 1 ? 15 : 2;
      this.orderLoop(type);
      this.log(`订单轮询_${type === 1 ? "已完成订单" : "未完成订单"}`);
    },

    orderLoop(i) {
      if (this.wait > 0) {
        this.onPayment(i);
        this.wait--;
        this.preventShow = true;
        Indicator.open();

        setTimeout(() => {
          this.orderLoop(i);
        }, 1500);
      } else {
        this.preventShow = false;
      }
    },

    onPayment(i) {
      checkOrderAPI({
        trade_no: this.order,
        periods: this.currentPeriod,
      }).then((response) => {
        if (Number(response.code) === 200) {
          this.wait = 0;

          if (i === 1) this.onToast(response.message, 2000);

          this.getSuccessPayContainer();
          this.buyAnniversaryShow = false;
          this.preventShow = false;
          Indicator.close();

          return;
        }

        if (Number(response.code) !== 200 && this.wait === 0) {
          if (i === 1) this.onToast(response.message, 2000);
          this.paymentFailedShow = true;
          Indicator.close();
        }
      });
    },

    closeAnniversary() {
      this.buyAnniversaryShow = false;
    },
    validateAddress(address) {
      const value = String(address || "").trim();

      if (!value) {
        this.onToast("详细收货地址不能为空");
        return false;
      }

      // 不能是纯数字
      if (/^\d+$/.test(value)) {
        this.onToast("详细地址不能为纯数字");
        return false;
      }

      if (value.length < 5) {
        this.onToast("详细地址不能少于5个字");
        return false;
      }

      if (value.length > 80) {
        this.onToast("详细地址不能超过80个字");
        return false;
      }

      // 不能全是符号
      if (!/[\u4e00-\u9fa5a-zA-Z0-9]/.test(value)) {
        this.onToast("详细地址格式不正确");
        return false;
      }

      /**
       * 重点：
       * 必须包含至少一个中文或英文字母。
       * 这样可以拦截：
       * 123-456
       * 1-2-301
       * #301
       * 88-2-101
       */
      if (!/[\u4e00-\u9fa5a-zA-Z]/.test(value)) {
        this.onToast("详细地址需包含街道、小区、楼栋或门牌等信息");
        return false;
      }

      // 禁止 emoji
      if (/[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(value)) {
        this.onToast("详细地址不能包含表情符号");
        return false;
      }

      // 禁止高风险特殊字符
      if (/[<>"'`\\&|]/.test(value)) {
        this.onToast("详细地址不能包含特殊字符");
        return false;
      }

      /**
       * 允许：
       * 中文、英文、数字、空格
       * 常见地址符号：- # _ / 、 ， , 。 . ： : ； ; （ ） ( )
       */
      const addressReg =
        /^[\u4e00-\u9fa5a-zA-Z0-9\s\-#_/、，,。.：:；;（）()]+$/;

      if (!addressReg.test(value)) {
        this.onToast("详细地址格式不正确，请勿输入特殊符号");
        return false;
      }

      return true;
    },
    submitInfo() {
      const filterSpaces = (str) => {
        return String(str || "").replace(/\s/g, "");
      };

      if (this.odd_number !== 0 && this.odd_number !== "") {
        this.onToast("已成功发货，可复制单号查询物流！");
        return;
      }

      const params = {
        name: filterSpaces(this.name),
        phone: filterSpaces(this.phone),
        address: String(this.address || "").trim(),
        provincial: this.provincial,
        city: this.city,
        area: this.area,
        periods: this.currentPeriod,
      };

      if (!params.name) {
        this.onToast("收件人姓名不能为空");
        return;
      }

      const phoneRegex = /^1[3-9]\d{9}$/;

      if (!phoneRegex.test(params.phone)) {
        this.onToast("请输入有效的手机号码");
        return;
      }

      if (!params.provincial || !params.city || !params.area) {
        this.onToast("省市区不能为空");
        return;
      }

      if (!this.validateAddress(params.address)) {
        return;
      }

      modifyAddressApi(params).then((res) => {
        if (res.code === 200) {
          this.getLoginContainer();
          this.addressShow = false;
          this.onToast(res.message);
        } else {
          if (res.message === "很抱歉,请求参数不正确") {
            this.onToast("尚未完成地址填写");
            return;
          }

          this.onToast(res.message);
        }

        this.log("点击确认收货地址的按钮");
      });
    },

    getReward() {
      if (!this.canBuy) {
        this.onToast("还未到领取时间");
        return;
      }

      getRewardApi({
        periods: this.currentPeriod,
      })
        .then((response) => {
          if (Number(response.code) === 200) {
            this.welfareShow = false;
            this.getLoginContainer();
            this.log("点击领取福利礼包的按钮");
          }

          this.onToast(response.message);
        })
        .catch(() => {
          this.onToast("服务器出错啦");
        });
    },

    isExpensiveItem(item) {
      if (item && item.expensive) {
        this.expensiveShow = true;
        this.log("点击贵重品");
      }
    },

    startCountdown() {
      if (this.timer) clearInterval(this.timer);

      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
          this.compCountdown = this.timeFormatted(this.countdown);
        } else {
          this.canBuy = true;
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },

    showImage(src) {
      this.nowImg = src;
      this.previewShow = true;
      this.log("点击查看大图");
    },

    openPayDialog(buyType) {
      if (!this.userInfo.role_id) {
        this.changeLoginPopup(true);
        return false;
      }

      if (buyType === 1) {
        this.setClickStatus("secondClick", false);
        this.secondNoClick = false;
        this.buyType = buyType;
        this.buyAnniversaryShow = true;
        this.rewardShowList = this.anniversaryRewards;
      } else if (buyType === 2) {
        this.setClickStatus("thirdClick", false);
        this.thirdNoClick = false;
        this.buyType = buyType;
        this.buyAnniversaryShow = true;
        this.rewardShowList = this.collectorRewards;
      } else {
        this.setClickStatus("firstClick", false);
        this.firstNoClick = false;
        this.welfareShow = true;
      }

      if (this.is_pay && (buyType === 1 || buyType === 2)) {
        this.buyType = buyType === 1 ? 3 : 4;
      }

      this.log("查看对应礼包的按钮");
    },

    anniverSarySwiper() {
      new Swiper(".swiper-container", {
        ...commonConfig,
        direction: "vertical",
      });
    },

    isSetShare(linkUrl) {
      const share = this.activityConfig.share || {};

      this.setShare({
        link: linkUrl + `${getTimeStamp()}`,
        title: share.title,
        imgUrl: share.imgUrl,
        desc: share.desc,
      });
    },

    getSuccessPayContainer() {
      onGetInitDataAPI({
        periods: this.currentPeriod,
      })
        .then((response) => {
          this.isWhite = Number(response.code) !== 403;

          if (Number(response.code) === 200) {
            const activity = response.data.activity || {};

            this.actual_quantity = activity.actual_quantity;
            this.odd_number = activity.odd_number;
            this.is_pay = activity.is_pay;
            this.name = activity.name;
            this.phone = activity.phone;
            this.address = activity.address;
            this.countdown = activity.countdown;
            this.end_address = activity.end_address;
            this.reawrd_status = activity.reawrd_status;
            this.old_order = activity.old_order;
            this.end_time = activity.end_time || "";

            this.compCountdown = this.timeFormatted(this.countdown);

            if (this.timer) clearInterval(this.timer);
            if (this.timer1) clearInterval(this.timer1);

            this.startCountdown();
            this.initCountdown();
            this.onInitDataCallback(response);

            this.canBuy = !(this.countdown > 0);

            if (this.is_pay === 1 || this.is_pay === 2) {
              this.addressShow = true;
            }

            return;
          }

          Number(response.code) !== 401 && this.onToast(response.message);
        })
        .catch(() => {
          this.onToast("服务器出错啦");
        });
    },

    async getLoginContainer() {
      if (localStorage.getItem(this.videoStorageKey)) {
        setTimeout(() => {
          this.preloadingShow = false;
        }, 1000);
      } else {
        this.preloadingShow = true;
      }

      await onGetInitDataAPI({
        periods: this.currentPeriod,
      })
        .then((response) => {
          if (Number(response.code) === 200) {
            const activity = response.data.activity || {};

            this.actual_quantity = activity.actual_quantity || false;
            this.odd_number = activity.odd_number || "";
            this.is_pay = activity.is_pay || PAY_STATUS.UNPAID;

            this.name = activity.name || "";
            this.phone = activity.phone || "";
            this.address = activity.address || "";

            this.countdown = activity.countdown || 0;
            this.end_address = activity.end_address || false;
            this.reawrd_status = activity.reawrd_status || false;
            this.old_order = activity.old_order || null;
            this.end_time = activity.end_time || "";

            this.area = activity.area || "";
            this.city = activity.city || "";
            this.provincial = activity.provincial || "";

            this.selected = this.provincial + " " + this.city + " " + this.area;

            this.canBuy = !(this.countdown > 0);
            this.compCountdown = this.timeFormatted(this.countdown);

            if (this.timer) clearInterval(this.timer);
            if (this.timer1) clearInterval(this.timer1);

            this.initCountdown();
            this.startCountdown();
            this.onInitDataCallback(response);

            this.firstNoClick = this.getClickStatus("firstClick");
            this.secondNoClick = this.getClickStatus("secondClick");
            this.thirdNoClick = this.getClickStatus("thirdClick");
          }

          this.isWhite = Number(response.code) !== 403;

          if (Number(response.code) !== 403) {
            setTimeout(() => {
              if (localStorage.getItem(this.videoStorageKey)) {
                this.showVideo = "hidden";
              } else {
                this.$nextTick(() => {
                  this.video();
                });
              }
            }, 1001);
          }

          if (response.message !== "ok") {
            Number(response.code) !== 401 && this.onToast(response.message);
          }
        })
        .catch(() => {
          this.onToast("服务器出错啦");
        });

      setTimeout(() => {
        this.preloadingShow = false;
      }, 5000);
    },

    clearActiveInfo() {
      this.firstNoClick = true;
      this.secondNoClick = true;
      this.thirdNoClick = true;
      this.odd_number = "";
      this.actual_quantity = true;
      this.is_pay = 0;
      this.canBuy = true;

      if (this.timer) clearInterval(this.timer);
      if (this.timer1) clearInterval(this.timer1);

      hasActualQuality({
        periods: this.currentPeriod,
      }).then((response) => {
        if (Number(response.code) === 200) {
          this.actual_quantity = response.data.actual_quantity;
        } else {
          this.onToast(response.message);
        }
      });

      this.getLoginContainer();
    },

    selectCallback() {
      if (this.timer) clearInterval(this.timer);

      this.getLoginContainer();

      this.firstNoClick = this.getClickStatus("firstClick");
      this.secondNoClick = this.getClickStatus("secondClick");
      this.thirdNoClick = this.getClickStatus("thirdClick");
    },

    setClickStatus(keySuffix, status) {
      const roleName =
        this.userInfo && this.userInfo.role_name
          ? this.userInfo.role_name
          : "guest";

      window.localStorage.setItem(
        `${this.currentPeriod}_${roleName}_${keySuffix}`,
        JSON.stringify(status)
      );
    },

    getClickStatus(keySuffix) {
      const roleName =
        this.userInfo && this.userInfo.role_name
          ? this.userInfo.role_name
          : "guest";

      const storedValue = window.localStorage.getItem(
        `${this.currentPeriod}_${roleName}_${keySuffix}`
      );

      return this.userInfo.role_name
        ? storedValue !== null
          ? JSON.parse(storedValue)
          : true
        : true;
    },

    osCancell() {
      this.clearActiveInfo();
    },

    onToast(config, duration = 1000) {
      const curConfig = {
        duration,
        className: "toasts",
      };

      if (!config) {
        console.error("缺少config参数");
        return false;
      }

      if (typeof config === "string") {
        curConfig.message = config;
      }

      Toast(curConfig);
    },

    ...mapMutations([
      "changeLoginPopup",
      "changeOsPopup",
      "setInitActiveInfo",
      "setInitUserInfo",
      "setLogger",
    ]),

    ...mapActions(["onInitDataCallback", "setShare"]),
  },

  beforeDestroy() {
    window.removeEventListener("pageshow", this.resize);
    window.removeEventListener("resize", this.resize);

    if (this.timer) clearInterval(this.timer);
    if (this.timer1) clearInterval(this.timer1);

    const video = this.$refs.openingVideo;
    if (video && video.pause) {
      video.pause();
    }
  },

  computed: {
    currentPeriod() {
      return Number(this.activityConfig.periods || 3);
    },

    videoStorageKey() {
      return `lookedVideo_${this.currentPeriod}`;
    },

    swiperList() {
      return [
        {
          photo: this.activityConfig.home.medalFront,
        },
        {
          photo: this.activityConfig.home.medalBack,
        },
      ].filter((item) => item.photo);
    },

    welfareRewards() {
      return this.activityConfig.welfare.rewards || [];
    },

    anniversaryRewards() {
      return this.activityConfig.anniversary.rewards || [];
    },

    collectorRewards() {
      return this.activityConfig.collector.rewards || [];
    },

    rightTitleClass() {
      if (this.userInfo.role_id && this.is_pay === 1) return "right-title-4";
      if (this.userInfo.role_id && this.is_pay === 2) return "right-title-5";
      if (!this.canBuy && this.actual_quantity) return "right-title-1";
      if (this.canBuy && this.actual_quantity && this.is_pay === 0)
        return "right-title-2";
      if (this.canBuy && !this.actual_quantity && this.is_pay === 0)
        return "right-title-3";
      return "";
    },

    rightTitleStyle() {
      let url = "";

      if (this.userInfo.role_id && this.is_pay === 1) {
        url = this.activityConfig.home.rightTitlePaidAnniversary;
      } else if (this.userInfo.role_id && this.is_pay === 2) {
        url = this.activityConfig.home.rightTitlePaidCollector;
      } else if (!this.canBuy && this.actual_quantity) {
        url = this.activityConfig.home.rightTitleBeforeSale;
      } else if (this.canBuy && this.actual_quantity && this.is_pay === 0) {
        url = this.activityConfig.home.rightTitleOnSale;
      } else if (this.canBuy && !this.actual_quantity && this.is_pay === 0) {
        url = this.activityConfig.home.rightTitleSoldOut;
      }

      return this.bg(url);
    },

    anniversaryTitleClass() {
      const typeMap = {
        1: "first-anniversary",
        2: "second-anniversary",
        3: "third-anniversary",
        4: "four-anniversary",
      };

      return typeMap[this.buyType] || "";
    },

    anniversaryTitleStyle() {
      let url = "";

      if (this.buyType === 1) {
        url = this.activityConfig.anniversary.titleImage;
      } else if (this.buyType === 2) {
        url = this.activityConfig.collector.titleImage;
      } else if (this.buyType === 3) {
        url =
          this.activityConfig.anniversary.ownedTitleImage ||
          this.activityConfig.anniversary.titleImage;
      } else if (this.buyType === 4) {
        url =
          this.activityConfig.collector.ownedTitleImage ||
          this.activityConfig.collector.titleImage;
      }

      return this.bg(url);
    },

    anniversaryMedalStyle() {
      if (this.buyType === 1 || this.buyType === 3) {
        return this.bg(this.activityConfig.anniversary.medalImage);
      }

      if (this.buyType === 2 || this.buyType === 4) {
        return this.bg(
          this.activityConfig.collector.medalImage ||
            this.activityConfig.anniversary.medalImage
        );
      }

      return this.bg("");
    },

    anniversaryDescClass() {
      if (this.buyType === 1 || this.buyType === 3) return "first-desc";
      if (this.buyType === 2 || this.buyType === 4) return "second-desc";
      return "";
    },

    addressFields() {
      return [
        {
          key: "name",
          class: "name_class",
          type: "text",
        },
        {
          key: "phone",
          class: "phone_class",
          type: "text",
          maxlength: "11",
        },
        {
          key: "selected",
          class: "city_class",
          type: "text",
          readonly: true,
        },
      ];
    },

    btnClasses() {
      if (this.userInfo.role_id && this.is_pay > 0) {
        return {
          welfare: "welfare-btn-uni",
          notTime: "not_time_btn",
          bottomText: "bottom-text",
        };
      }

      if (this.rewardPanelType === 3) {
        return {
          welfare: "welfare-btn",
          notTime: "not_time_btn-uni",
          bottomText: "bottom-text",
          anniversary: "anniversary-btn",
        };
      }

      return {
        welfare: "welfare-btn-no",
        notTime: "not_time_btn-no",
        bottomText: "bottom-text-no",
        anniversary: "anniversary-btn-no",
      };
    },

    rewardPanelType() {
      if (!this.actual_quantity) return 2;
      if (this.is_pay === 1) return 3;
      return 3;
    },

    formattedTime() {
      const h = String(Math.floor(this.remainingSeconds / 3600)).padStart(
        2,
        "0"
      );
      const m = String(
        Math.floor((this.remainingSeconds % 3600) / 60)
      ).padStart(2, "0");
      const s = String(this.remainingSeconds % 60).padStart(2, "0");
      return `${h}:${m}:${s}`;
    },

    ...mapState(["userInfo", "activeInfo", "isShowLogin", "isShowOs"]),
  },

  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (!newValue.role_id) {
          this.osCancell();
        } else if (
          oldValue &&
          (newValue.role_id !== oldValue.role_id ||
            newValue.account !== oldValue.account)
        ) {
          this.firstNoClick = this.getClickStatus("firstClick");
          this.secondNoClick = this.getClickStatus("secondClick");
          this.thirdNoClick = this.getClickStatus("thirdClick");

          hasActualQuality({
            periods: this.currentPeriod,
          }).then((response) => {
            if (Number(response.code) === 200) {
              this.actual_quantity = response.data.actual_quantity;
            } else {
              this.onToast(response.message);
            }
          });
        }
      },
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./index.less");

/deep/ .custom-popup {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  overflow: hidden;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
  background: #fff;
}

/deep/ .van-area {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  overflow: hidden;
  background: #fff;
}

/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  font-size: 30px !important;
}

/deep/ .van-picker-column__item {
  font-size: 30px !important;
}

/deep/ .van-picker {
  min-height: 300px !important;
}

.opening-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.address-medal {
  position: absolute;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
</style>



// WEBPACK FOOTER //
// src/pages/snail/anniversaryBadge/index/index.vue